import { render, staticRenderFns } from "./ErrorToast.vue?vue&type=template&id=28fc0ebc&scoped=true"
import script from "./ErrorToast.vue?vue&type=script&lang=js"
export * from "./ErrorToast.vue?vue&type=script&lang=js"
import style0 from "./ErrorToast.vue?vue&type=style&index=0&id=28fc0ebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fc0ebc",
  null
  
)

export default component.exports